import { Routes } from '@angular/router';
import { HomePage } from './home.page';
import { ProjectResolver } from 'src/app/services/project-resolver.service';

export const HOME_ROUTES: Routes = [
  {
    path: '',
    component: HomePage,
    children: [
      {
        path: '',
        redirectTo: 'feed',
        pathMatch: 'full',
      },
      {
        path: 'feed',
        loadComponent: () =>
          import('../feed/feed.page').then((m) => m.FeedPage),
      },
      {
        path: 'project',
        loadComponent: () =>
          import('../project/project.page').then((m) => m.ProjectPage),
        resolve: { ProjectResolver },
      },
      {
        path: 'search',
        loadComponent: () =>
          import('../search/search.page').then((m) => m.SearchPage),
      },
      {
        path: 'participation',
        loadComponent: () =>
          import('../participation/participation.page').then(
            (m) => m.ParticipationPage
          ),
      },
      {
        path: 'projects',
        loadComponent: () =>
          import('../projects/projects.page').then((m) => m.ProjectsPage),
      },
      {
        path: 'settings',
        loadComponent: () =>
          import('../settings/settings.page').then((m) => m.SettingsPage),
      },
    ],
  },
];
